<script setup lang="ts">
import { computed } from "vue";

import type {
    BaseInputProps,
    BaseInputEmits,
} from "@/shared/components/temparary/components/base/input/BaseInputModel";

const props = defineProps<BaseInputProps>();
const emits = defineEmits<BaseInputEmits>();

const conditionClass = computed(() => {
    return {
        "border-custom-border-gray focus-visible:border-primary-blue": props.validation == true,
        "border-primary-red focus-visible:border-primary-red":
            props.value && props.value.length > 0 && props.validation === false,
        "cursor-not-allowed": props.disabled,
    };
});

const emitInputValue = (event: Event) => {
    emits("emitInputValue", (event.target as HTMLInputElement).value);
};
</script>

<template>
    <div class="flex items-center justify-center w-full h-auto">
        <input
            :type="props.type"
            :value="props.value"
            class="border border-custom-border-gray placeholder-primary-gray text-base block w-full py-[1.1rem] px-[1.2rem] transition appearance-none outline-hidden"
            :class="conditionClass"
            :required="props.required"
            :disabled="props.disabled || false"
            :placeholder="props.placeholder"
            :maxlength="maxlength"
            @input="emitInputValue"
        />
    </div>
</template>

<style scoped></style>
